import { request } from "../../utils/config"
export const UPDATE_USER_PASSWORD = async (data) => {
  const response = await request({
    url: `Users`,
    method: "PUT",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const CHANGE_USER_PASSWORD = async (data: { currentPassword: string; newPassword: string; confirmPassword: string }) => {
  const response = await request({
    url: `Users/ChangePassword`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const CREATE_USER = async (data) => {
  const response = await request({
    url: `Users`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const UPLOAD_PROFILE_PHOTO = async (data: { PhotoBase64: string; OldFileName?: string }) => {
  const response = await request({
    url: `Users/UploadProfilePhoto`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const DELETE_PROFILE_PHOTO = async (data: { OldFileName?: string }) => {
  const response = await request({
    url: `Users/DeleteProfilePhoto`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
